//#region libraries
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import ConfirmBookingRetired from '_scenes/website/confirm-booking-retired';

// pax requests desk
import PaxRequests from '_scenes/portal/pax-requests';
import LegacyAppBookings from '_scenes/portal/pax-requests/legacy-bookings';
import LanyardOrders from '_scenes/portal/lanyard-orders';

// prm bookings
import BookingCalendar from "_scenes/portal/prm-bookings/calendar";
import BookingList from "_scenes/portal/prm-bookings/booking-list";

// assistance bookings
import BookingsHome from "_scenes/portal/assistance-bookings/bookings-home";
import CreateBooking from "_scenes/portal/assistance-bookings/create-booking";
import BookingRequests from "_scenes/portal/assistance-bookings/booking-requests";
import BookingHistory from "_scenes/portal/assistance-bookings/booking-history";
import BookingAnalytics from "_scenes/portal/analytics/booking-analytics/index";
import SeasonalVariances from '_scenes/portal/analytics/booking-analytics/seasonalVariances';
// feedback
import Analytics from "_scenes/portal/analytics";
import ReviewList from "_scenes/portal/analytics/review-list";

// marketplace
import Marketplace from "_scenes/portal/marketplace/marketplace/index";
import MarketplaceList from "_scenes/portal/marketplace/marketplace-list";
import CreateProduct from "_scenes/portal/marketplace/create-product";
import EditReward from "_scenes/portal/marketplace/edit-reward";
import ProductInformation from '_scenes/portal/marketplace/product-information';
import ProductSales from '_scenes/portal/marketplace/product-information/product-sales';
import TransactionInformation from '_scenes/portal/marketplace/product-information/transaction-information';

// marketplace
import Rewards from "_scenes/portal/prm-club/rewards";
import MyRewardsList from "_scenes/portal/prm-club/my-rewards-list";
import CreateReward from "_scenes/portal/prm-club/create-reward";

// analytics
import GlobalSla from "_scenes/portal/analytics/global-sla";
import AirportProfile from "_scenes/portal/analytics/airport-profile";
import BeaconDetails from "_scenes/portal/analytics/beacon-details";

// messaging 
import MessagingPage from "_scenes/portal/support-desk/messaging/index";
import SupportDesk from '_scenes/portal/support-desk';

// incident reports
import IncidentReports from '_scenes/portal/incident-reports';

// archive
import Archive from '_scenes/portal/archive';

// logout
import Logout from '_scenes/portal/utils/logout';

// acount
import Account from "_scenes/portal/profile/account";
import AdminPanel from "_scenes/portal/profile/admin-panel"
import StaffManagement from "_scenes/portal/profile/staff-management"
import EditAccount from "_scenes/portal/profile/edit-account"
import Contact from "_scenes/portal/profile/contact"
import fire from "_utils/firebase";
import AirportSelector from '_scenes/portal/profile/airport-selector';
import UserProfile from '../scenes/portal/profile/user-profile';

// timeline
import Timeline from '../scenes/portal/timeline/timeline-components/index';
import TimelineV2 from '../scenes/portal/timeline-v2/timeline-components/index';
import EmployeeSettings from '../scenes/portal/timeline/employee-components/employee-settings';
import FlightScanner from '../scenes/portal/timeline/timeline-components/flight-scanner';
import EmployeeScanner from '_scenes/portal/timeline/timeline-components/employee-scanner';

// total reports
import TotalReports from '_scenes/portal/total-reports';

// timeline reports
import TimelineReportsIndex from '_scenes/portal/total-reports/timeline-reports-index';

// retailer form
import RetailerForm from '../components/organisms/marketplace/retailer-form';

// dev
import WaitTimesList from '../components/organisms/feedback/wait-times-list';

// utils
import NotVerifiedScreen from "_scenes/portal/profile/not-verified";

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { setTravelAgent, selectTravelAgent, selectUserDb } from '_redux/slices/main-screen/user';
import QAPage from '_scenes/portal/qa';
import UpdatesPage from '_scenes/portal/notifications';
import { getPosts } from '_redux/slices/notifications/notifications';
//#endregion

import Testing from '../scenes/portal/utils/testing';
import TimelineComponent from '../scenes/portal/timeline/timeline-components/timeline-component';
import TimelineComponentV2 from '../scenes/portal/timeline-v2/timeline-components/timeline-component';
import ForceReset from '_scenes/portal/utils/force-reset';
import FlightInformation from '_scenes/portal/prm-bookings/flights/flight-information';
import TimelineJobs from '_scenes/portal/timeline/job-components/timeline-jobs';
import { logout } from '_redux/slices/main-screen/user';

import RetailerNavigation from '_scenes/portal/marketplace/retailer-navigation';
import TimelineAnalyticsComponent from '_scenes/portal/timeline/timeline-components/timeline-analytics-component';
import ControlPanelComponent from '_scenes/portal/timeline/timeline-components/control-panel-component';
import LiveLocationScene from '../scenes/portal/timeline/live-locations-components/live-location-scene';
import AssetTrackingTab from '../scenes/portal/timeline/asset-tracking-components';

// api data
import ApiDataScreen from '_scenes/portal/api-data';

// remote check-in (public — no auth)
import RemoteCheckinPage from '_scenes/remotecheckin';
import SurveyPreview from '_scenes/website/survey-preview';

const AppRouter = () => {
  //#region redux
  const dispatch = useDispatch();
  const userDb = useSelector(selectUserDb);
  const travelAgent = useSelector(selectTravelAgent);
  //#endregion  

  const [showRetailerForm, setShowRetailerForm] = useState(false);
  const [retailerNavigation, setRetailerNavigation] = useState(false);

  useEffect(() => {
    document.body.classList.add('portal-view');
    return () => document.body.classList.remove('portal-view');
  }, []);

  useEffect(() => {
    if (userDb) {
      if (userDb.position && userDb.position == 'RETAILER') {
        // need to check if user is verified
        if (userDb.verified == false) {
          console.log('not verified')
          setShowRetailerForm(true)
          //setRetailerNavigation(true)
        }
      }
      // else {
      //   dispatch(getPosts())
      // }
    }
  }, [userDb]);

  useEffect(() => {
    // travel agent
    if (userDb && userDb.details && userDb.details.type == 'TRAVEL_AGENT') {
      dispatch(setTravelAgent(true))
    }
    else {
      dispatch(setTravelAgent(false))
    }
  }, [userDb]);

  // Passenger requests and lanyard order desks handle passenger data on shared PCs:
  // keep the Firebase session in sessionStorage only, so closing the tab/browser
  // signs the desk user out. Other roles keep the default (local) persistence.
  useEffect(() => {
    if (userDb?.role !== "PAX_REQUESTS_DESK" && userDb?.role !== "LANYARD_ORDERS_DESK" && userDb?.role !== "AIRLINE_PAX_DESK") return;
    fire.auth()
      .setPersistence(fire.auth.Auth.Persistence.SESSION)
      .catch((e) => console.log('Error setting session persistence', e));
  }, [userDb?.role]);

  //#endregion



  const handleRetailerRegistration = () => {
    // retailer account has been created, need to show retailer navigation
    setShowRetailerForm(false)
    setRetailerNavigation(true)
  }

  // retailer logged in
  if (retailerNavigation) {
    return (
      <Router>
        <Switch>
          <Route path="/">
            <RetailerNavigation />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
        </Switch>
      </Router>
    )
  }
  // show retailer registration screen if user is a retailer and not verified
  if (showRetailerForm) {
    return (
      <Router>
        <Switch>
          <Route path="/">
            <RetailerForm submitted={() => { handleRetailerRegistration() }} />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (userDb && userDb.verified && userDb.role === "RETAILER") {
    return (
      <Router>
        <Switch>
          <Route path="/login">
            <Marketplace />

          </Route>

          <Route path="/marketplace">
            <Marketplace />
          </Route>
          <Route path='/product-information'>
            <ProductInformation />
          </Route>
          <Route path='/product-sales'>
            <ProductSales />
          </Route>

          <Route path='/transaction-information'>
            <TransactionInformation />
          </Route>
          <Route path="/support-desk">
            <SupportDesk />
          </Route>
          <Route path='/account'>
            <Account />
          </Route>
          <Route path='/admin-panel'>
            <AdminPanel />
          </Route>
          <Route path="/create-product">

            <CreateProduct />
          </Route>
          <Route path="/view-products">

            <MarketplaceList />
          </Route>

          <Route path='/edit-account'>
            <EditAccount />
          </Route>
          <Route path="/">
            <Marketplace />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (userDb && !userDb.verified && userDb.role === "RETAILER") {
    return (
      <Router>
        <Switch>
          <Route path="/login">
            <RetailerForm submitted={() => { handleRetailerRegistration() }} />

          </Route>

        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "REPORTS_ONLY"
  ) {
    return (
      <Router>
        <Switch>
          <Route path="/timeline-reports">
            <TimelineReportsIndex />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/timeline-reports" />
          </Route>
          <Route path="*">
            <Redirect to="/timeline-reports" />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "PAX_REQUESTS_DESK"
  ) {
    // Passenger requests desk: requests plus the read-only old app list. UI guard — the server enforces access.
    return (
      <Router>
        <Switch>
          <Route path="/pax-requests">
            <PaxRequests />
          </Route>
          <Route path="/old-app-bookings">
            <LegacyAppBookings />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/pax-requests" />
          </Route>
          <Route path="*">
            <Redirect to="/pax-requests" />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "AIRLINE_PAX_DESK"
  ) {
    // Airline passenger requests desk: one carrier-scoped page. UI guard — the server enforces access.
    return (
      <Router>
        <Switch>
          <Route path="/pax-requests">
            <PaxRequests airlineMode />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/pax-requests" />
          </Route>
          <Route path="*">
            <Redirect to="/pax-requests" />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "LANYARD_ORDERS_DESK"
  ) {
    // Lanyard orders desk: one page only. UI guard — the server enforces access.
    return (
      <Router>
        <Switch>
          <Route path="/lanyard-orders">
            <LanyardOrders />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/lanyard-orders" />
          </Route>
          <Route path="*">
            <Redirect to="/lanyard-orders" />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "BOOKINGS_FEEDBACK"
  ) {
    return (
      <Router>
        <Switch>
          <Route path="/prm-calendar">
            <BookingCalendar />
          </Route>
          <Route path="/create-booking">
            <CreateBooking />
          </Route>
          <Route path="/feedback">
            <Analytics />
          </Route>
          <Route path="/account">
            <Account />
          </Route>
          <Route path="/edit-account">
            <EditAccount />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/prm-calendar" />
          </Route>
          <Route path="*">
            <Redirect to="/prm-calendar" />
          </Route>
        </Switch>
      </Router>
    )
  }
  if (
    userDb &&
    fire.auth().currentUser &&
    userDb.verified &&
    fire.auth().currentUser.emailVerified &&
    userDb.role === "SECURITY"
  ) {
    return (
      <Router>
        <Switch>

          {/*
          <Route path="/prm-calendar">
            <BookingCalendar />
          </Route>
          */}

          <Route path="/prm-bookings">
            <BookingList />
          </Route>
          <Route path="/account">
            <Account />
          </Route>
          <Route path="/edit-account">
            <EditAccount />
          </Route>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/login">
            <Redirect to="/prm-bookings" />
          </Route>
          <Route path="*">
            <Redirect to="/prm-bookings" />
          </Route>
        </Switch>
      </Router>
    )
  }
  return userDb && fire.auth().currentUser && userDb.verified && fire.auth().currentUser.emailVerified ?
    <Router>
      <Switch>

        <Route path="/login">
          {userDb.details.type === "AIRLINE" && userDb.details.authority === "ALL" ? <BookingsHome /> : <BookingCalendar />}
        </Route>

        {/* old email confirm link — retired, kept so old emails land somewhere */}
        <Route path="/confirm-booking/:id/:airport">
          <ConfirmBookingRetired />
        </Route>

        {/* ForceReset */}
        <Route path="/force-reset">
          <ForceReset />
        </Route>
        {/* Calendar */}
        <Route path="/prm-calendar">
          <BookingCalendar />
        </Route>

        {/* Booking List */}
        <Route path="/prm-bookings">
          <BookingList />
        </Route>

        {/* Assistance Bookings Home */}
        <Route path="/assistance-bookings">
          <BookingsHome />
        </Route>

        <Route path="/create-booking">
          <CreateBooking />
        </Route>

        <Route path="/booking-history">
          <BookingHistory />
        </Route>

        <Route path="/booking-request">
          {
            travelAgent ? null :
              <BookingRequests />
          }
        </Route>

        <Route path="/seasonal-variances">
          {
            userDb.details.type === "AIRPORT" ?
              <SeasonalVariances /> : null
          }
        </Route>

        {/* Feedback Home */}
        <Route path="/feedback">
          {
            travelAgent ? null :
              <Analytics />
          }
        </Route>

        <Route path="/beacon-details">
          {travelAgent ? null :
            <BeaconDetails />
          }
        </Route>

        {/* Analytics */}
        <Route path="/analytics">
          {travelAgent ? null :
            <BookingAnalytics />}
        </Route>

        <Route path="/global-sla">
          {travelAgent ? null :
            <GlobalSla />}
        </Route>

        <Route path="/messaging">
          <MessagingPage />
        </Route>

        <Route path="/QAPage">
          <QAPage />
        </Route>

        <Route path="/notifications">
          <UpdatesPage />
        </Route>

        <Route path="/airport-profile">
          {travelAgent ? null :
            <AirportProfile />}
        </Route>

        {/* Trip Reviews */}
        <Route path="/review-list">
          {travelAgent ? null :
            <ReviewList />}
        </Route>

        {/* Marketplace */}
        <Route path="/marketplace">
          {travelAgent ? null :
            <Marketplace />}
        </Route>

        <Route path='/product-information'>
          <ProductInformation />
        </Route>

        <Route path='/product-sales'>
          <ProductSales />
        </Route>

        <Route path='/transaction-information'>
          <TransactionInformation />
        </Route>

        <Route path="/create-product">
          {travelAgent ? null :
            <CreateProduct />
          }
        </Route>

        <Route path="/view-products">
          {travelAgent ? null :
            <MarketplaceList />}
        </Route>

        <Route path="/edit-product">
          {travelAgent ? null : <EditReward />}
        </Route>

        <Route path='/testing'>
          <Testing />
        </Route>

        {/* Account */}
        <Route path='/account'>
          <Account />
        </Route>

        <Route path='/admin-panel'>
          <AdminPanel />
        </Route>

        <Route path='/staff-management'>
          {(userDb.role === 'ADMIN' || userDb.role === 'GARETH') ? <StaffManagement /> : <Redirect to="/account" />}
        </Route>

        <Route path='/edit-account'>
          <EditAccount />
        </Route>

        <Route path='/contact-us'>
          <Contact />
        </Route>

        <Route path='/account-selector'>
          <AirportSelector />
        </Route>

        <Route path="/user-profile">
          <UserProfile />
        </Route>
        <Route path="/flight-information">
          <FlightInformation />
        </Route>

        <Route path="/support-desk">
          <SupportDesk />
        </Route>

        <Route path="/incident-reports">
          <IncidentReports />
        </Route>

        <Route path="/archive">
          <Archive />
        </Route>

        <Route path="/timeline">
          <Timeline />
        </Route>

        <Route path="/timeline-view">
          <TimelineComponent />
        </Route>
        <Route path="/timeline-v2">
          <TimelineV2 />
        </Route>

        <Route path="/timeline-view-v2">
          <TimelineComponentV2 />
        </Route>

        <Route path="/timeline-analytics">
          <TimelineAnalyticsComponent />
        </Route>

        <Route path="/timeline-control-panel">
          <ControlPanelComponent />
        </Route>
        <Route path="/timeline-jobs">
          <TimelineJobs />
        </Route>


        <Route path="/employee-settings">
          <EmployeeSettings />
        </Route>

        <Route path="/flight-scan">
          <FlightScanner />
        </Route>

        <Route path="/employee-scan">
          <EmployeeScanner />
        </Route>


        <Route path="/live-locations">
          <LiveLocationScene />
        </Route>

        {/*<Route path="/total-reports">
          <TotalReports />
        </Route>*/}

        <Route path="/api-data">
          <ApiDataScreen />
        </Route>

        <Route
          path="/total-reports"
          render={(props) => (
            <TotalReports {...props} timeline={props.location.state?.timeline ?? false} />
          )}
        />

        <Route path="/timeline-reports">
          <TimelineReportsIndex />
        </Route>

        <Route path="/logout">
          <Logout />
        </Route>

        <Route path="/asset-tracking">
          <AssetTrackingTab />
        </Route>

        <Route path="/survey-preview/:iata/:surveyId">
          <SurveyPreview />
        </Route>

        <Route path="/">
          <BookingCalendar />
        </Route>


      </Switch>
    </Router>
    : userDb && fire.auth().currentUser && (userDb.verified == false || !fire.auth().currentUser.emailVerified) ?
      <Router>
        <Switch>

          <Route path="/login">
            <NotVerifiedScreen />
          </Route>

        </Switch>
      </Router>
      :
      <Router>
        <Switch>
          <Route path="/logout">
            <Logout />
          </Route>
          <Route path="/">

          </Route>
        </Switch>
      </Router>

};

export default AppRouter;
